import React from 'react';
import {
    COVER_DIM_ON_LIGHT,
    COVER_DISPLAY_FONT_VAR,
    CoverLogo,
    coverPsychologistLine,
    coverTitleSize,
    withAlpha,
    type CoverTemplateProps,
} from './shared';

/** Editorial assimétrica: assinatura na lombada, título ancorado na base. */
export const Lombada: React.FC<CoverTemplateProps> = ({ fields, colors, logoUrl, showLogo }) => {
    const hairline = withAlpha(colors.primary, 0.28);
    const psychologist = coverPsychologistLine(fields);
    const hasBottomMeta = Boolean(fields.patient_name || fields.solicitante || fields.city_date);

    return (
        <div className="flex size-full">
            <div
                className="flex w-[2.6em] items-end justify-center border-r py-[1.6em]"
                style={{ borderColor: hairline }}
            >
                {psychologist ? (
                    <span
                        className="rotate-180 whitespace-nowrap text-[0.52em] uppercase tracking-[0.28em]"
                        style={{ writingMode: 'vertical-rl', color: COVER_DIM_ON_LIGHT }}
                    >
                        {psychologist}
                    </span>
                ) : null}
            </div>
            <div className="flex flex-1 flex-col px-[2.6em] pb-[2.4em] pt-[2.6em]">
                <div className="flex justify-end">
                    <CoverLogo logoUrl={logoUrl} showLogo={showLogo} className="h-[2.4em]" />
                </div>
                <div className="mt-auto">
                    {fields.subtitle ? (
                        <div
                            className="mb-[1.4em] font-semibold uppercase tracking-[0.32em]"
                            style={{
                                fontSize: coverTitleSize(0.62),
                                color: colors.primary,
                            }}
                        >
                            {fields.subtitle}
                        </div>
                    ) : null}
                    <div
                        className="font-bold leading-[1.04] tracking-[-0.02em]"
                        style={{
                            fontFamily: COVER_DISPLAY_FONT_VAR,
                            fontSize: coverTitleSize(3),
                            maxWidth: '7em',
                        }}
                    >
                        {fields.document_title}
                    </div>
                </div>
                {hasBottomMeta ? (
                    <div
                        className="mt-[1.8em] flex items-end justify-between border-t pt-[1.2em] text-[0.62em] leading-[1.75]"
                        style={{ borderColor: hairline, color: COVER_DIM_ON_LIGHT }}
                    >
                        <div>
                            {fields.patient_name ? (
                                <div className="text-[1.18em] font-semibold text-[#16181d]">
                                    {fields.patient_name}
                                </div>
                            ) : null}
                            {fields.solicitante ? <div>{fields.solicitante}</div> : null}
                        </div>
                        {fields.city_date ? <div>{fields.city_date}</div> : null}
                    </div>
                ) : null}
            </div>
        </div>
    );
};
